// extracted by mini-css-extract-plugin
export default {"DayInner":"Tour_DayInner__MUI3O","BookBtn":"Tour_BookBtn__D9HdQ"};